import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faLink } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule, Text } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useIntegrationData from '@hooks/useIntegrationData'

import ButtonWithOAuth from '@components/ButtonWithOAuth'

import ActiveImageUrl from './assets/active.svg'
import InactiveImageUrl from './assets/inactive.svg'

const Domain = (props: { selectedAgencyId: number }) => {
  const { selectedAgencyId } = props

  const integrationDataPayload = useIntegrationData({
    performHttpRequests: !!selectedAgencyId,
    requestOptions: { agency_id: selectedAgencyId, service_provider: 'domain_group' },
  })

  const {
    hasActiveSession,
    integrationData,
  } = integrationDataPayload

  const connectedAccountId = digObject(integrationData, 'data.username', 'Unknown')

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Domain Group">
      <DashboardModule.BlankState
        imageBoxProps={{ justifyContent: ['center', 'flex-end'] }}
        imageUrl={hasActiveSession ? ActiveImageUrl : InactiveImageUrl}
      >
        <DashboardModule.BlankState.Title>Connect Your Domain Account</DashboardModule.BlankState.Title>

        <DashboardModule.BlankState.Paragraph>
          You can connect your Domain account to Realhub for items like product pricing, suburb information and
          listing views.
        </DashboardModule.BlankState.Paragraph>

        <DashboardModule.BlankState.Paragraph>
          For your account security, Domain requests that you re-authorise this connection every 15 days.
        </DashboardModule.BlankState.Paragraph>
      </DashboardModule.BlankState>

      <DashboardModule.Footer boxProps={{ flexDirection: ['column', 'row'] }}>
        <Text color="faintGrey" fontSize="xsmall" marginBottom={['large', 0]}>
          {hasActiveSession
            ? `Account: ${connectedAccountId}`
            : 'Click Connect to Domain and enter your credentials'}
        </Text>

        <DashboardModule.FooterRight>
          <ButtonWithOAuth
            authProviderKey="domain_group"
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={hasActiveSession ? faCheck : faLink} />}
            queryParams={{
              agency_id: selectedAgencyId,
              origin: window.location.href,
            }}
            size="medium"
          >
            {hasActiveSession ? 'Connected to Domain' : 'Connect to Domain'}
          </ButtonWithOAuth>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Domain
